import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import {
  ErrorDetails
} from '../../interfaces/apiInterfaces';

export class GetDriverBasicInfoCommand extends IRequestCommand<
  IGetDriverBasicInfoResponse,
  ErrorDetails,
  IGetDriverBasicInfoCommandParameters
> {
  override _commandType: CommandRequestType = CommandRequestType.GET;
  override _commandUrl = 'drivers/basicInfo/{id}?driverId=';
  public override setParameters(parameters: IGetDriverBasicInfoCommandParameters) {
    this._commandUrl = this._commandUrl + parameters.driverId.toString();
    this._commandUrl = this._commandUrl.replace(
      '{id}',
      parameters.driverId.toString()
    );
  }
}

export interface IGetDriverBasicInfoCommandParameters extends ICommandParameters {
  driverId?: number;
}

export interface IGetDriverBasicInfoResponse extends ICommandResponse { }
